import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    color?: string;
    width?: number;
    height?: number;
};

export const RouteGuideIcon = ({ color = 'currentColor', width = 28, height = 28, ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={scaleWidthPixel(width)}
            height={scaleHeightPixel(height)}
            viewBox="0 0 28 28"
            fill="none"
            {...props}
        >
            <path
                d="M3.7638 7.01895H17.8399C20.069 7.01895 21.8759 8.82592 21.8759 11.0549C21.8759 13.2839 20.069 15.0909 17.8399 15.0909H11.3742C9.1497 15.0909 7.34639 16.8942 7.34639 19.1187C7.34639 21.3432 9.1497 23.1465 11.3742 23.1465H16.386"
                stroke={color}
                strokeWidth="2"
            />
            <ellipse cx="21.8761" cy="23.1466" rx="2.6498" ry="2.6498" stroke={color} strokeWidth="2" />
            <path d="M7.08235 3L3 7.08235L7.08235 11.1647" stroke={color} strokeWidth="1.75" />
        </svg>
    );
};
